import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
// import { ILogin, IPermissionProps } from "../../../models/Login";
import { Fetch } from "../../shared/Fetch";
// import { Filter } from "../Filter";
// import { Publish } from "../Publish";
// import { IAllRequirements } from "../../../models/AllRequirements";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
// import { IReqFilter, EmptyFilter } from "../Filter";
import { Tag } from 'primereact/tag';
// import { SubmissionsTable } from "./SubmissionsTable";
// import { POReport } from "./POReport";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IAllRequirements } from "../../models/AllRequirements";
import { Toast } from "primereact/toast";
import { Publish } from "../requirement/Publish";
import { EmptyFilter, Filter, IReqFilter } from "./Filter";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { User } from "../jvConnect/User";
import { Job_Type, Publish_Type, Req_Term } from "../../models/RequirementMast";

interface Iprops {
    toast?: any,
    reload?: boolean,
    setReload?: (is: boolean) => void,
    permissions: IPermissionProps
}

export interface IModel2 {
    open: boolean,
    singleData: IAllRequirements
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>, loading: boolean });
    const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
    const [loading, setLoading] = useState<boolean>(false);
    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    const [poDetails, setPODetails] = useState({ vendor_Company_ID: 0, open: false } as { vendor_Company_ID: number, open: boolean });
    const hidePODetailsDialog = () => {
        setPODetails({ vendor_Company_ID: 0, open: false });
    };
    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };
    const [rrr, setRRR] = useState({ open: false, rrreason: "", req_ID: 0 } as { open: boolean, rrreason: string | undefined, req_ID: number | undefined });
    const hideRRRDialog = () => {
        setRRR({ open: false, rrreason: "", req_ID: 0 });
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Float/recruiterFloatedReq", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(reqFilter)) + `&tb=${3}`, props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json();
            setTableData({
                tableData: data.map((rowData: any) => {
                    return { ...rowData, recruiter: (rowData.recruiter || "").split(',').map((ele: string) => (ele.trim().split("-")[0] + '-' + ele.trim().split("-")[1])).join(", ") }
                }), loading: false
            });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
                </React.Fragment>
                : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Floated Requirements</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <div style={{ display: 'flex' }}>
                </div>
            </span>
        </div>
    );

    const req_Job_Title = (rowData: IAllRequirements) => {
        return rowData.rejected_Status === "Yes" ?
            <span onClick={() => {
                setPublish({ singleData: rowData, open: true });
                setRRR({ open: true, rrreason: rowData.rejected_Comment, req_ID: rowData.req_ID })
            }}
                className="cursor-pointer underline">
                <Tag severity="danger" value={rowData.req_Job_Title} />
            </span>
            : rowData.req_EditedBy ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer underline">
                <Tag severity="warning" value={rowData.req_Job_Title} />
            </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_Job_Title}
            </span>;
    };
    const pDate = (rowData: IAllRequirements) => {
        let date;
        if (rowData.pDate) date = format(new Date(rowData.pDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    // const fDate = (rowData: IAllRequirements) => {
    //     let date;
    //     if (rowData.float_Global_On) date = format(new Date(rowData.float_Global_On), 'dd/MM/yyyy HH:mm').toUpperCase()
    //     else if (rowData.float_Company_On) date = format(new Date(rowData.float_Company_On), 'dd/MM/yyyy HH:mm').toUpperCase()
    //     else date = "";
    //     return (<>{date}</>);
    // };

    const [subTable, setSubTable] = useState({ req_id: 0, job_Title: "", open: false } as { req_id: number, job_Title?: string, open: boolean });
    const hideSubTable = () => {
        setSubTable({ req_id: 0, job_Title: "", open: false });
    };

    const submission_id = (rowData: IAllRequirements) => {
        const countOfSubmissions = rowData.submission_id?.split(', ').length;
        const color = countOfSubmissions ? 'green' : rowData.recruiter ? 'yellow' : 'skyblue';
        return (<div style={{ background: color, minWidth: '70px', minHeight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3px' }}>
            {_roles.includes(4) ? <span className="text-white">{rowData.submission_id}</span> : <span className="text-white">{countOfSubmissions}</span>}
        </div>);
    };



    const floatButton = (rowData: IAllRequirements) => {
        if (rowData.hold) {
            return (rowData.company_ID == 4 ? (<div style={{ display: 'grid', marginTop: '5px' }}>
                {/* {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={(rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? 'Comp + Global Float' : 'Floated'} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"} */}
                {/* {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={(rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? ' Float' : 'Floated'} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"} */}
            </div>) : <div style={{ display: 'grid', marginTop: '5px' }}>
                {/* {(rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? 'Within Comp' : ((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} */}
                {rowData.publish_Type !== Publish_Type.Globally ? ' Float' : 'Floated'}
            </div>);
        }
    }

    useEffect(() => {
        loadTableData();
    }, [reqFilter, props.reload]);

    const DataFromat = loginObj.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={4} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" sortable />
                <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                <Column field="req_Duration" header="Duration" />
                <Column field="req_CategoryName" header="Category" sortable />
                <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                <Column field="special_Constraint" header="Special Constraint" />
                {/* <Column field="pDate" header="Posted On" body={pDate} /> */}
                <Column field="pDate" header="Posted On" style={{ minWidth: "100px" }} body={(rowData: any) => safeFormatDate(rowData.pDate, "dd/MM/yyyy", DataFromat)} />
                {/* <Column header="Floated On" body={fDate} /> */}
                <Column header="Floated On" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate((rowData.publish_At), "dd/MM/yyyy", DataFromat, true)} />
                <Column field="user_Name" sortable header="Sales Manager"
                    body={(r: IAllRequirements) => <User req={{
                        reqId: r.req_ID ?? '',
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.pDate ?? '',
                        userId: r.req_PostedBySalesManager ?? 0,
                        userName: r.user_Name ?? '',
                    }}
                    />} />
                <Column field="salesCompany" header="Sales Comp(Branch)" />
                <Column field="recruiter" header="Recruiter" />
                <Column field="submission_id" header="Submittals" body={submission_id} />
                <Column field="client_Communication" sortable header="Client Communication" />
                <Column field="hold" header="Status" body={(rowData: IAllRequirements) => rowData.hold ? "Hold" : "Unhold"} />
                {/* <Column field="Float" body={floatButton} style={{ minWidth: '6rem' }} /> */}

            </DataTable>
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            <Dialog visible={rrr.open} style={{ width: '80vw' }} header={`Requirement - (${rrr.req_ID}) Rejection Reason`} className="p-fluid" onHide={hideRRRDialog}>
                <JVSunEditor value={rrr.rrreason} />
            </Dialog>
        </>
    );
}
